import React, { useEffect, useState } from 'react';
import {withRouter} from 'react-router';
import PaginationList from "../../common/Paginator/PaginationList";
import LatestNews from "../../common/LatestNews/LatestNews";
import CateMenu from "../../common/CateMenu/CateMenu";
import NewsItem from "../../common/NewsItem/NewsItem";
import NewsDetail from "../../common/NewsDetail/NewsDetail";
import {getPolicyCate} from "./service";


const PolicyMore = (props) => {
    const { history, match } = props;
    const [newsDetailVisible, setNewsDetailVisible] = useState(false);
    const [policyCate, setPolicyCate] = useState([]);

    useEffect(() => {
        (async () => {
            const policyCate = await getPolicyCate();
            setPolicyCate(policyCate.data.list);
        })();
    }, []);

    useEffect(() => {
        setNewsDetailVisible(!!match.params.id)
    }, [match]);

    return (
        <div style={{width: 1200, display: 'flex'}}>
            <div style={{marginRight: 16}}>
                <CateMenu
                    title="业务范围"
                    data={policyCate}
                    onClick={({item, keyPath}) => {
                        history.push({pathname: `/policy/more/${keyPath[0]}/${item.props.children}`})
                    }}
                />
                <div style={{height: 16}}/>
                <LatestNews/>
            </div>
            {
                newsDetailVisible
                    ?   <NewsDetail url="/api/PolicyConsult"/>
                    :   <PaginationList
                        title={match.params.title}
                        url={`/api/PolicyConsult?cate_id=${match.params.cateId}`}
                        renderItem={item => <NewsItem {...item} url={`/policy/more/${match.params.cateId}/${match.params.title}`}/>}
                    />
            }
        </div>
    )
};

export default withRouter(PolicyMore);
